import React, {useState} from 'react';
import {LoadedImage} from "../EmblaCarousel/FactionsCarousel";
import PageButton from "../elements/PageButton/PageButton";
import './YandexAuthPage.css';
import {goToYandexAuth} from '../../utils/auth/goToYandexAuth';
import VersionLabel from '../VersionLabel/VersionLabel';
import MusicMuteToggleButton from '../MusicMuteToggleButton/MusicMuteToggleButton';
import {usePageAnalytics} from '../../hooks/analytics/usePageAnalytics';
import EmailAuthForm from './EmailAuthForm';

function YandexAuthPage({onDevLogin, onEmailAuthSuccess}) {
  const isDev = process.env.NODE_ENV === 'development';
  // Форма почты раскрывается на месте кнопок: отдельный экран здесь не нужен,
  // а возврат к выбору способа входа должен быть в один клик
  const [isEmailFormOpen, setIsEmailFormOpen] = useState(false);

  // Единственный экран, который раньше не отчитывался о показе: клики по входу
  // было не с чем сравнить — неизвестно, сколько людей вообще его увидели
  usePageAnalytics('YandexAuthPage');

  return (
    <>
      <MusicMuteToggleButton pageId={'YandexAuthPage'}/>
      <LoadedImage
        className={'loading-screen-bust main-menu-bust margin-top-auto'}
        src={'/img/other/strategikon_bust.png'}
      />
      <h1 className="auth-page-title">Стратегикон</h1>
      <div className="yandex-auth-page-buttons">
        {isEmailFormOpen ? (
          <EmailAuthForm
            onAuthSuccess={onEmailAuthSuccess}
            onCancel={() => setIsEmailFormOpen(false)}
          />
        ) : (
        <>
        <PageButton
          onClick={() => setIsEmailFormOpen(true)}
          pageId="YandexAuthPage"
          buttonId="email-login-open"
        >
          {/* Значок и раскладка — как у кнопки Яндекса ниже */}
          <span className="yandex-auth-button-content">
            <img className="yandex-auth-icon" src="/img/icons/email.png" alt=""/>
            Войти по email
          </span>
        </PageButton>
        <PageButton onClick={goToYandexAuth} pageId="YandexAuthPage" buttonId="yandex-login">
          <span className="yandex-auth-button-content">
            <img
              className="yandex-auth-icon"
              src="/img/icons/yandex.png"
              alt=""
            />
            Войти c
            <span
              className="yandex-auth-service-name"
            >
              Яндекс ID
            </span>
          </span>
        </PageButton>
        {isDev && (
          <PageButton onClick={onDevLogin} pageId="YandexAuthPage" buttonId="dev-login">
            Войти dev
          </PageButton>
        )}
        </>
        )}
      </div>
      <div className="auth-page-copyright">
        {`™ Стратегикон, ${new Date().getFullYear()}, все права защищены`}
      </div>
      <VersionLabel/>
    </>
  );
}

export default YandexAuthPage;
